import { TwitterChannelType } from './twitter-channel-type.enum';
var TwitterChannelDataBuilder = /** @class */ (function () {
    function TwitterChannelDataBuilder() {
        this.twitterChannelData = {
            messageId: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            senderId: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0c',
            accountId: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0d',
            twitterChannelType: TwitterChannelType.DIRECT_MESSAGE,
        };
    }
    TwitterChannelDataBuilder.prototype.withMessageId = function (messageId) {
        this.twitterChannelData.messageId = messageId;
        return this;
    };
    TwitterChannelDataBuilder.prototype.withSenderId = function (senderId) {
        this.twitterChannelData.senderId = senderId;
        return this;
    };
    TwitterChannelDataBuilder.prototype.withAccountId = function (accountId) {
        this.twitterChannelData.accountId = accountId;
        return this;
    };
    TwitterChannelDataBuilder.prototype.withType = function (type) {
        this.twitterChannelData.twitterChannelType = type;
        return this;
    };
    TwitterChannelDataBuilder.prototype.build = function () {
        return this.twitterChannelData;
    };
    return TwitterChannelDataBuilder;
}());
export { TwitterChannelDataBuilder };
//# sourceMappingURL=twitter-channel-data.builder.js.map